import React, { Fragment } from "react";

import img13 from "../../../images/service/Smart Contract Audit Services/1.png";
import img14 from "../../../images/service/Smart Contract Audit Services/2.png";
import img15 from "../../../images/service/Smart Contract Audit Services/3.png";
// Service icons
import sIcon1 from "../../../images/icon/service-icon01.svg";
import sIcon2 from "../../../images/icon/service-icon02.svg";
import sIcon3 from "../../../images/icon/service-icon03.svg";
import sIcon4 from "../../../images/icon/service-icon04.svg";
import sIcon5 from "../../../images/icon/service-icon05.svg";
import sIcon6 from "../../../images/icon/service-icon06.svg";

// Common Components
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";

import HeroSection from "../../../components/PageSection/HeroSection";
import ServiceCardsSection from "../../../components/PageSection/ServiceCardSection";
import Benefit from "../../../components/PageSection/BenefitSection";
import KeyFeaturesSection from "../../../components/PageSection/KeyFeature";
import WhyChooseUsSection from "../../../components/PageSection/WhyChooseUsSection";
import FaqSection from "../../../components/PageSection/FAQsection";
import FinalCenteredCTA from "../../../components/PageSection/FinalCTA";
import Industries from "../../../components/Industries/Industries";
import TheorySection from "../../../components/PageSection/Theory";

// =====================
// DATA
// =====================

const serviceCards = [
  {
    icon: sIcon1,
    title: "Custom Smart Contract Development",
    content:
      "We design and develop secure, efficient smart contracts tailored to your business logic and blockchain ecosystem.",
  },
  {
    icon: sIcon2,
    title: "Smart Contract Auditing",
    content:
      "Identify vulnerabilities and optimize contract performance with in-depth manual and automated audits.",
  },
  {
    icon: sIcon3,
    title: "Token Smart Contracts",
    content:
      "Develop ERC, BEP, and custom token contracts with minting, burning, and governance logic.",
  },
];

const benefits = [
  {
    title: "Trustless Execution",
    description:
      "Smart contracts execute automatically without intermediaries, ensuring trust and transparency.",
    icon: sIcon1,
  },
  {
    title: "Enhanced Security",
    description:
      "Cryptographic mechanisms protect business logic and prevent unauthorized changes.",
    icon: sIcon2,
  },
  {
    title: "Cost Efficiency",
    description:
      "Automation reduces manual processing costs and eliminates middlemen.",
    icon: sIcon3,
  },
  {
    title: "Accuracy & Reliability",
    description:
      "Predefined logic removes human errors and ensures consistent outcomes.",
    icon: sIcon4,
  },
];

const faqs = [
  {
    q: "What is a smart contract?",
    a: "A smart contract is a self-executing program stored on a blockchain that runs automatically when predefined conditions are met.",
  },
  {
    q: "Which blockchains support smart contracts?",
    a: "Ethereum, Binance Smart Chain, Polygon, Solana, Cardano, Avalanche, and other programmable blockchains.",
  },
  {
    q: "Why is smart contract auditing important?",
    a: "Auditing ensures security, prevents vulnerabilities, and protects assets from exploits.",
  },
  {
    q: "Can smart contracts be upgraded?",
    a: "Yes. Upgradeable smart contract patterns allow future enhancements without breaking functionality.",
  },
];

// =====================
// PAGE COMPONENT
// =====================

export default function SmartContractDevelopment() {
  return (
    <Fragment>
      <Header />

      <PageTitle
        pageTitle="Smart Contract Development"
        pagesub="Secure, automated & decentralized contract solutions"
      />

      {/* HERO SECTION */}
      <HeroSection
        title={
          <>
            Build Secure & Reliable{" "}
            <span className="gradient-text">Smart Contracts</span>
          </>
        }
        subtitle={`Automate agreements, transactions, and workflows using
secure, audited smart contracts across leading blockchain platforms.`}
        buttonText="Book Consultation"
        buttonLink="/contact"
        image={img13}
        imageAlt="Smart Contract Development"
      />

      {/* ================= THEORY 1 ================= */}
      <TheorySection
        title="What Are Smart Contracts?"
        image={img14}
        paragraphs={[
          "Smart contracts are self-executing digital agreements deployed on blockchain networks. They automatically perform actions when predefined conditions are satisfied.",
          "By removing intermediaries, smart contracts enable faster execution, lower costs, and increased trust across decentralized ecosystems.",
        ]}
      />

      {/* SERVICES */}
      <ServiceCardsSection
        title="Our Smart Contract Services"
        cards={serviceCards}
      />

      {/* ================= THEORY 2 ================= */}
      <TheorySection
        title="Why Smart Contracts Matter"
        image={img15}
        paragraphs={[
          "Traditional contracts rely on manual enforcement, intermediaries, and lengthy processing times.",
          "Smart contracts replace this with automated, transparent execution, making them ideal for DeFi, NFTs, supply chain, gaming, and enterprise systems.",
        ]}
      />

      {/* BENEFITS */}
      <Benefit
        title="Benefits of Smart Contract Development"
        benefits={benefits}
      />

      {/* KEY FEATURES */}
      <KeyFeaturesSection
        title="Key Features of Our Smart Contracts"
        subtitle="Engineered for security, scalability, and efficiency"
        features={[
          {
            icon: sIcon1,
            title: "Immutable Logic",
            description:
              "Once deployed, contract logic cannot be altered maliciously.",
          },
          {
            icon: sIcon2,
            title: "Automated Execution",
            description:
              "Triggers actions instantly when conditions are met.",
          },
          {
            icon: sIcon3,
            title: "Multi-Chain Compatibility",
            description:
              "Deploy contracts across Ethereum, BSC, Polygon, and more.",
          },
          {
            icon: sIcon4,
            title: "Gas Optimization",
            description:
              "Efficient coding to reduce transaction costs.",
          },
          {
            icon: sIcon5,
            title: "Upgradeable Architecture",
            description:
              "Future-proof designs with proxy patterns.",
          },
          {
            icon: sIcon6,
            title: "Security Audits",
            description:
              "Thorough testing to eliminate vulnerabilities.",
          },
        ]}
      />

      <Industries />

      {/* WHY CHOOSE US */}
      <WhyChooseUsSection
        items={[
          "Blockchain security specialists",
          "Audited & production-ready contracts",
          "End-to-end smart contract lifecycle support",
        ]}
      />

      {/* FAQ */}
      <FaqSection faqs={faqs} />

      {/* FINAL CTA */}
      <FinalCenteredCTA />

      <Footer />
      <Scrollbar />
    </Fragment>
  );
}
